require('./dist/angular-gettext.js');
module.exports = 'gettext';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-gettext/index.js
 ** module id = 377
 ** module chunks = 0
 **/